
<div class="controller-card" id="container" >
    <button class="close-button" (click)="modalClose()">✕</button>
    <a class="act-alarm-filter" (click)="filterPopUp()"><img src="assets/img/action-alarm-filter.svg" ></a>
<div class="alarm-sidepanel-heading"><img src="assets/img/alarm-sidebar-icon.svg" class="mx-2">Alarm History</div>
<div  class="pop-up-div" *ngIf="popUp">
  <div class="device-style">
      <p >Device</p>
      <div class="device-inner-div">
        <span><img src="assets/img/action-alarm-filter.svg" [src]="getImagePath(deviceDetails.device_id)" class="ms-2 device-image"></span>
        <p class="text-uppercase">{{deviceDetails.device_id}}</p>
      </div>
  </div>
  <div  class="alarm-info-div">
    <p >Type</p>
    <div class="inner-alarm-info-div" >
      <div (click)="getAlarms(1)" [ngClass]="{'alarm-type-style':isCritical}" class="common-style"> 
        <img src="assets/img/critical-alarm-ico.svg"  class="alarm-image">
        <button  > CRITICAL</button></div>
      <div   (click)="getAlarms(2)" [ngClass]="{'alarm-type-style':!isCritical && !allAlarmsCheckbox}" class="common-style ml-4">
        <img src="assets/img/info.svg"  class="alarm-image">
        <button  >INFO</button>
      </div>
  </div>
  <div  class="radio-class">
    <input
    type="radio"
    [value]="2"
    name="uploadAction"
    [checked]="allAlarmsCheckbox"
    (click)="getAlarms()"
  /> 
  </div>
  <label for=""  class="label">ALL ALARMS</label>

  </div>
</div>

  <div *ngIf="hasAlarms;else noAlarms">
    <div class="alarm-section" *ngFor="let d of filterdArray | keyvalue:originalOrder">
      <h4>{{d.key | customDate}} </h4>
      <div class="alarm-card" *ngFor="let data of d?.value">
        <span class="alarm-icon"><img [src]="getImagePath(deviceDetails.device_id)" height="35px" width="35px"></span>
        <div class="alarm-content">
          <span class="critical"><img [src]="getCriticalInfoPath(data.alert_type)" alt="" width="12px" height="11px"> {{criticalInfoAlarms(data.alert_type)}}</span>
          <p >{{data.alert_message}}</p>
          <p *ngIf="data.bit_delete == 1" class="resolved-text">Resolved {{data?.resolved_date_time| customDate : alamResolvedTime}}</p>
        </div>
        <span class="time">{{data.date_time| customDate : alarmGeneratedTime}}</span>
      </div>
    </div>
  </div>

</div>
  
<ng-template #noAlarms>
  <div class="no-alarms">No alarms present</div>
</ng-template>
